(function() {
  'use strict';

  function openModal(modal, overlay) {
    overlay.classList.add('ds-quote--open');
    modal.classList.add('ds-quote--open');
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function() { requestAnimationFrame(function() {
      overlay.classList.add('ds-quote--visible');
      modal.classList.add('ds-quote--visible');
    }); });
  }

  function closeModal(modal, overlay) {
    overlay.classList.remove('ds-quote--visible');
    modal.classList.remove('ds-quote--visible');
    document.body.style.overflow = '';
    setTimeout(function() {
      overlay.classList.remove('ds-quote--open');
      modal.classList.remove('ds-quote--open');
      modal.querySelectorAll('input, textarea').forEach(function(el) { el.value = ''; });
    }, 260);
  }

  function makeEl(tag, attrs, textContent) {
    var el = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function(k) {
      if (k === 'style') el.style.cssText = attrs[k];
      else el.setAttribute(k, attrs[k]);
    });
    if (textContent !== undefined) el.textContent = textContent;
    return el;
  }

  function getProductName() {
    var f = document.querySelector('[name="contact[product]"]');
    if (f && f.value) return f.value.trim();
    var h1 = document.querySelector('h1');
    return h1 ? h1.textContent.trim() : document.title;
  }

  function styleCustomizeLi(customizeLi) {
    var titleSpan = customizeLi.querySelector('.custom-select__option-title');
    if (!titleSpan || titleSpan.querySelector('.ds-imperial')) return;
    var text = titleSpan.textContent.trim();
    var match = text.match(/^(Customize)\s*(\(.+\))$/);
    if (match) {
      titleSpan.textContent = '';
      titleSpan.appendChild(document.createTextNode(match[1] + ' '));
      var sub = document.createElement('span');
      sub.className = 'ds-imperial';
      sub.textContent = match[2];
      titleSpan.appendChild(sub);
    }
  }

  function maybeShowSuccessToast() {
    if (window.location.search.indexOf('quote_sent=1') === -1) return;
    var toast = makeEl('div', {
      style: 'position:fixed;bottom:32px;left:50%;transform:translateX(-50%);background:#000;color:#fff;padding:14px 28px;font-size:13px;letter-spacing:0.08em;z-index:99999;opacity:0;transition:opacity 0.3s;pointer-events:none;white-space:nowrap;'
    }, 'Your quote request has been sent. We\u2019ll be in touch soon.');
    document.body.appendChild(toast);
    requestAnimationFrame(function() { requestAnimationFrame(function() { toast.style.opacity = '1'; }); });
    setTimeout(function() {
      toast.style.opacity = '0';
      setTimeout(function() { toast.parentNode && toast.parentNode.removeChild(toast); }, 400);
    }, 4000);
    if (window.history && window.history.replaceState) {
      window.history.replaceState({}, '', window.location.pathname);
    }
  }

  function submitQuote(form, displayName, nameVal, emailVal, msgVal, submitBtn) {
    submitBtn.disabled = true;
    submitBtn.textContent = 'Sending...';

    var setF = function(name, val) {
      var el = form.querySelector('[name="' + name + '"]');
      if (el) el.value = val;
    };
    setF('contact[name]', nameVal);
    setF('contact[email]', emailVal);
    setF('contact[message]', 'Product: ' + displayName + '\n\nCustom size inquiry:\n' + msgVal);

    var ret = form.querySelector('[name="return_to"]');
    if (!ret) { ret = document.createElement('input'); ret.type = 'hidden'; ret.name = 'return_to'; form.appendChild(ret); }
    ret.value = window.location.pathname + '?quote_sent=1';

    // Only call captcha.protect once per form - track with a flag
    if (!form._captchaProtected) {
      if (window.Shopify && window.Shopify.captcha && window.Shopify.captcha.protect) {
        window.Shopify.captcha.protect(form);
      }
      form._captchaProtected = true;
    }

    // Use nativeSubmitBtn.click() so captcha.protect event listener fires properly
    var nativeSubmitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
    if (nativeSubmitBtn) {
      nativeSubmitBtn.click();
    } else {
      // Fallback: dispatch submit event
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }

    // Reset button after 8s in case form didn't navigate (e.g. validation failed)
    setTimeout(function() {
      if (submitBtn.disabled) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'GET A QUOTE';
      }
    }, 8000);
  }

  function run() {
    if (!window.location.pathname.match(/\/products\//)) return;

    var nativeSelect = document.querySelector('select.custom-select__native');
    var atcBtn = document.querySelector('button[name="add"]');
    var customizeLi = document.querySelector('li.ds-customize-option');

    if (!nativeSelect || !atcBtn || !customizeLi) return;
    if (document.querySelector('.ds-get-quote-btn')) return;

    styleCustomizeLi(customizeLi);

    var productName = getProductName();
    var displayName = 'Dinodo Studio \u2014 ' + productName;

    var atcHolder = atcBtn.closest('.product__cart-actions-holder') || atcBtn.parentElement;

    var quoteBtn = makeEl('button', {
      type: 'button',
      class: 'ds-get-quote-btn',
      style: 'display:none;width:100%;padding:16px;background:#000;color:#fff;border:none;font-family:inherit;font-size:13px;letter-spacing:0.12em;cursor:pointer;'
    }, 'GET A QUOTE');
    atcHolder.parentNode.insertBefore(quoteBtn, atcHolder.nextSibling);

    function showCustomize() { atcHolder.style.display = 'none'; quoteBtn.style.display = 'block'; }
    function showATC() { atcHolder.style.display = ''; quoteBtn.style.display = 'none'; }

    customizeLi.addEventListener('click', function(e) {
      e.stopPropagation();
      var cs = document.querySelector('custom-select');
      var txt = cs ? cs.querySelector('.custom-select__text') : null;
      if (txt) txt.textContent = 'Customize';
      var ul = document.querySelector('.custom-select__options');
      if (ul) ul.querySelectorAll('li').forEach(function(l) { l.classList.remove('is-selected'); });
      customizeLi.classList.add('is-selected');
      if (cs) cs.classList.remove('is-open');
      showCustomize();
    });

    var ul = document.querySelector('.custom-select__options');
    if (ul) {
      ul.querySelectorAll('li:not(.ds-customize-option)').forEach(function(li) {
        li.addEventListener('click', function() { showATC(); });
      });
    }

    var overlay = makeEl('div', { class: 'ds-quote-overlay' });
    var modal = makeEl('div', { role: 'dialog', 'aria-modal': 'true', class: 'ds-quote-modal' });

    var closeBtn = makeEl('button', { class: 'ds-quote-modal__close', 'aria-label': 'Close', type: 'button' }, '\u00d7');
    var titleEl = makeEl('p', { class: 'ds-quote-modal__title' }, 'GET A QUOTE');
    var productEl = makeEl('p', { class: 'ds-quote-modal__product' }, displayName);

    var formWrap = makeEl('div', { class: 'ds-quote-modal__form-wrap' });

    function makeField(labelText, tag, inputAttrs) {
      var field = makeEl('div', { class: 'ds-quote-modal__field' });
      var label = makeEl('label', { class: 'ds-quote-modal__label' }, labelText);
      var input = makeEl(tag, Object.assign({
        class: tag === 'textarea' ? 'ds-quote-modal__textarea' : 'ds-quote-modal__input',
        required: ''
      }, inputAttrs));
      field.appendChild(label);
      field.appendChild(input);
      return { field: field, input: input };
    }

    var nameF = makeField('Name *', 'input', { id: 'ds-quote-name', type: 'text', placeholder: 'Your name', autocomplete: 'name' });
    var emailF = makeField('Email *', 'input', { id: 'ds-quote-email', type: 'email', placeholder: 'your@email.com', autocomplete: 'email' });
    var msgF = makeField('Message *', 'textarea', { id: 'ds-quote-msg', placeholder: 'Tell us about the size, colors, or any customization details' });

    formWrap.appendChild(nameF.field);
    formWrap.appendChild(emailF.field);
    formWrap.appendChild(msgF.field);

    var submitBtn = makeEl('button', { class: 'ds-quote-modal__submit', type: 'button' }, 'GET A QUOTE');
    formWrap.appendChild(submitBtn);

    modal.appendChild(closeBtn);
    modal.appendChild(titleEl);
    modal.appendChild(productEl);
    modal.appendChild(formWrap);

    document.body.appendChild(overlay);
    document.body.appendChild(modal);

    quoteBtn.addEventListener('click', function() { openModal(modal, overlay); });
    closeBtn.addEventListener('click', function() { closeModal(modal, overlay); });
    overlay.addEventListener('click', function() { closeModal(modal, overlay); });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('ds-quote--open')) closeModal(modal, overlay);
    });

    submitBtn.addEventListener('click', function() {
      var n = nameF.input.value.trim();
      var em = emailF.input.value.trim();
      var msg = msgF.input.value.trim();
      if (!n) { nameF.input.focus(); return; }
      if (!em) { emailF.input.focus(); return; }
      if (!msg) { msgF.input.focus(); return; }

      var pageForm = document.querySelector('#contact_form');
      if (!pageForm) { alert('Form not found. Please refresh and try again.'); return; }

      submitQuote(pageForm, displayName, n, em, msg, submitBtn);
    });
  }

  maybeShowSuccessToast();

  var attempts = 0;
  function tryRun() {
    attempts++;
    var nativeSelect = document.querySelector('select.custom-select__native');
    var atcBtn = document.querySelector('button[name="add"]');
    var customizeLi = document.querySelector('li.ds-customize-option');
    if (nativeSelect && atcBtn && customizeLi) { run(); }
    else if (attempts < 40) { setTimeout(tryRun, 100); }
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', tryRun); }
  else { tryRun(); }
  document.addEventListener('page:load', function() { attempts = 0; tryRun(); });
  document.addEventListener('page:change', function() { attempts = 0; tryRun(); });
})();